import { useEffect } from 'react';

import { Typography } from '@mui/material';
import { useField } from 'formik';
import { BiPlus } from 'react-icons/bi';

import { Card, InvoiceLineItem } from 'src/components';
import { Flex } from 'src/components/Flex';
import { OptionTypes } from 'src/components/FormikComponents/DropDown';

import { createCreditNoteItem } from '..';

const CREDIT_NOTE_ITEMS_FIELD_NAME = 'creditNoteItems';

interface CreditNoteItemProps {
    ledgerAccounts: OptionTypes[];
}

const CreditNoteItem = ({ ledgerAccounts }: CreditNoteItemProps) => {
    const [{ value: creditNoteItems }, __, { setValue: setCreditNoteItems }] = useField(
        CREDIT_NOTE_ITEMS_FIELD_NAME
    );

    useEffect(() => {
        if (creditNoteItems.length === 0) {
            setCreditNoteItems([createCreditNoteItem()]);
        }
    }, [creditNoteItems, setCreditNoteItems]);

    const onAddCreditNoteItem = () => {
        setCreditNoteItems([...creditNoteItems, createCreditNoteItem()]);
    };

    const removeItem = (index) => {
        if (creditNoteItems.length > 1) {
            const updatedItems = creditNoteItems.filter((__, itemIndex) => {
                return itemIndex !== index;
            });
            setCreditNoteItems(updatedItems);
        }
    };

    return (
        <Card gap="36px">
            <Flex alignItems="center" justifyContent="space-between">
                <Typography fontSize="20px" fontWeight="500" lineHeight="30px" color="#1d1d1b">
                    Credit Note Items
                </Typography>
                <Flex gap="8px">
                    <Flex
                        padding="6px"
                        onClick={onAddCreditNoteItem}
                        sx={{ cursor: 'pointer' }}
                        bgcolor="black"
                        color="white"
                        borderRadius="4px"
                        data-testid="add-line-item"
                    >
                        <BiPlus size="14px" />
                    </Flex>
                </Flex>
            </Flex>

            {creditNoteItems.map((item, index) => {
                return (
                    <InvoiceLineItem
                        key={item.id}
                        index={index}
                        ledgerAccounts={ledgerAccounts}
                        formNamePrefix={CREDIT_NOTE_ITEMS_FIELD_NAME}
                        removeItem={index > 0 ? removeItem : undefined}
                    />
                );
            })}
        </Card>
    );
};

export default CreditNoteItem;
